<template>
    <v-dialog v-model="dlgModel" :content-class="shake">
      <v-card>
        <v-container>
          <v-row>
            <v-text-field id="custom-url-input" autofocus @keydown="onKeyDown" @keyup="onKeyUp" v-model="link.customUrlId">
              <template v-slot:prepend>
                <span class="url-prepend">https://b-t.one/</span>
              </template>
            </v-text-field>
          </v-row>
          <v-row v-if="linkExists">
            <span class="error--text">ShortUrl bereits vorhanden: {{existingLink.customUrlId}} -> ZielURL: <a :href="existingLink.targetUrl">{{existingLink.targetUrl}}</a> (Bemerkung: {{existingLink.comment}})</span>
          </v-row>
          <v-row>&nbsp;</v-row>
        </v-container>
      </v-card>
    </v-dialog>
</template>

<style>
.url-prepend {
  padding-top: 4px;
  white-space: nowrap;
}

.shake {
  animation: shake 0.82s cubic-bezier(.36,.07,.19,.97) both;
  transform: translate3d(0, 0, 0);
  backface-visibility: hidden;
  perspective: 1000px;
}

@keyframes shake {
  10%, 90% {
    transform: translate3d(-1px, 0, 0);
  }

  20%, 80% {
    transform: translate3d(2px, 0, 0);
  }

  30%, 50%, 70% {
    transform: translate3d(-4px, 0, 0);
  }

  40%, 60% {
    transform: translate3d(4px, 0, 0);
  }
}
</style>

<script>
import persistentStorage from "@/services/PersistentStorage";

export default {
  name: "CustomUrlEditDlg",
  data: () => ({
    shake: '',
    keyPressTimer: null,
    linkExists: false,
    existingLink: false
  }),
  props: {
    value: Boolean,
    link: Object
  },
  computed: {
    dlgModel: {
      get() {
        return this.value;
      },
      set() {
        this.$emit('cancel', true);
      }
    }
  },
  watch: {
    value(val) {
      if(val) {
        this.linkExists = false;
        this.existingLink = {};
      }
    }
  },
  methods: {
    onKeyDown(evt) {
      const allowedChars = ['0','1','2','3','4','5','6','7','8','9',
        'A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z',
        'a','b','c','d','e','f','g','h','i','j','k','l','m','n','o','p','q','r','s','t','u','v','w','x','y','z','-','Backspace','Enter','Shift','Alt','AltGraph','Control'];

      if(allowedChars.indexOf(evt.key) == -1) {
        evt.preventDefault();
        this.doShakeAnimation();
      }
    },
    doShakeAnimation() {
      this.shake = 'shake';
      setTimeout(function() {
        this.shake = '';
      }.bind(this), 1000);
    },
    onKeyUp(evt) {
      if(evt.key=='Enter') {

        if(this.linkExists) {
          this.doShakeAnimation();
          return;
        }
        if(this.keyPressTimer) {
          return;
        }
        this.$emit('save', this.value);
        return;
      }
      if(this.keyPressTimer) {
        clearTimeout(this.keyPressTimer);
      }
      this.keyPressTimer = setTimeout(function() {
        this.checkForExistingCustomUrl();
        this.keyPressTimer = false;
      }.bind(this), 300);
    },
    checkForExistingCustomUrl() {
      persistentStorage.getObjectList('links', {customUrlId: this.link.customUrlId}).then(
        function(result) {
          if(result.count > 0 && result.result[0].id !== this.link.id) {
            this.linkExists = true;
            this.existingLink = result.result[0];
          } else {
            this.linkExists = false;
            this.existingLink = {};
          }
        }.bind(this),
        function() {

        }
      )
    }
  }
}
</script>